@if (prestatie$ | async; as prestatie) {
  @if (client$ | async; as client) {
    @if (taakGeschiedenis$ | async; as taakGeschiedenis) {
      @if (dienst$ | async; as dienst) {
        @if (taakTipAantallen$ | async; as taakTipAantallen) {
          <zah-client-header [client]="client"
            [label]="dienst.getLabel()">
          </zah-client-header>
          <zah-prestatie-taken [prestatie]="prestatie"
            [taakGeschiedenis]="taakGeschiedenis"
            [dienst]="dienst"
            [taakTipAantallen]="taakTipAantallen"
            (dienstenClicked)="onDienstenClicked(prestatie)"
            (stopClicked)="onStopClicked(prestatie)"
            (meldingenClicked)="onMeldingenClicked(prestatie, client, dienst)"
            (signaalkaartenClicked)="onSignaalkaartenClicked(prestatie, client, dienst)"
            (clientFicheClicked)="onClientFicheClicked(client, dienst)"
            (taakSelected)="onTaakSelect(prestatie, $event)"
            (taakDeselected)="onTaakDeselect(prestatie, $event)"
            (tipsOpened)="onTipsOpened(client, $event)">
          </zah-prestatie-taken>
        }
      }
    }
  }
}
